import React, { Component } from 'react';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { Control, Errors, actions } from 'react-redux-form';
import ReactSelect from 'react-select';
import classnames from 'classnames';

class MultiSelect extends Component {
    constructor(props) {
        super(props);
        this.state = { categoryValue: [] };
    }

    handleSelectChange = value => {
        this.setState({ categoryValue: value });
        if (
            this.state.categoryValue.length === 0 &&
            this.props.model === 'event.category'
        ) {
            this.props.dispatch(actions.setTouched(this.props.model));
        }
    };

    onBlur = () => {
        if (
            this.state.categoryValue.length === 0 &&
            this.props.model === 'event.category'
        ) {
            this.props.dispatch(actions.setTouched(this.props.model));
        }
    };

    componentDidMount() {
        if (this.props.categories) {
            this.setState({ categoryValue: this.props.categories });
        }
        if (this.props.model === 'event.category') {
            this.props.dispatch(actions.setTouched(this.props.model));
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.selectedValues) {
            if (this.props.selectedValues !== nextProps.selectedValues) {
                this.setState({ categoryValue: nextProps.selectedValues });
            }
        }
        //For reporting filters category to reset the state values
        if (
            nextProps.model === 'reportingFilters.category' &&
            this.props.resetFilter
        ) {
            this.setState({ categoryValue: [] });
        }
    }

    render() {
        let reactSelect = props => <ReactSelect {...props} />;
        let formRowClassNames = classnames({
            form__row: true,
            'form__row--error': !this.props.valid && this.props.touched,
            'form__row--disabled': this.props.disabled
        });

        return (
            <div className={formRowClassNames}>
                <div className="form__label">
                    <span className="form__title">
                        {this.props.title}
                        {this.props.isRequired ? (
                            <span className="form__required">*</span>
                        ) : (
                            ''
                        )}
                    </span>
                </div>
                <Control.custom
                    model={this.props.model}
                    id={this.props.model}
                    component={reactSelect}
                    multi
                    value={this.state.categoryValue}
                    options={this.props.options}
                    onChange={this.handleSelectChange}
                    validators={this.props.validators}
                    onClose={this.onClose}
                    onBlur={this.onBlur}
                    joinValues
                    name={this.props.model}
                    disabled={this.props.disabled}
                    mapProps={{
                        onChange: props => props.onChange
                    }}
                />
                <Errors
                    wrapper={props => (
                        <div className="form__error-messages">
                            {props.children}
                        </div>
                    )}
                    className="errors"
                    model={this.props.model}
                    show="touched"
                    messages={this.props.messages}
                />
            </div>
        );
    }
}

const mapStateToProps = (state, { model }) => {
    return {
        valid: get(state.forms, `${model}.$form.valid`, false),
        touched: get(state.forms, `${model}.$form.touched`, false)
    };
};

export default connect(mapStateToProps)(MultiSelect);



// WEBPACK FOOTER //
// ./src/components/ui/multi-select.js